import RestModel from 'discourse/models/rest';

export default RestModel.extend({

});